import React, { Fragment } from 'react'
import {
  Copy,
  Hero,
  SectionFull,
  Testimonial,
  HeadingLines,
  Heading
} from '@website2018/da-dobsonville'
import { Helmet } from "react-helmet-async";
import { decode } from 'he';
import { noComma } from '../../common/utils'
import SliderWrapper from '../Slider/Slider'
import ListItem from '../Nav/ListItem'
import Spacing from '../Spacing/Spacing'
import NavigationContainer from '../../containers/Data/NavigationContainer'
import Stickers from '../Layout/Stickers'
import Governments from '../Governments/Governments'

const WWGTemplate = props => {
  const {
    page: p,
    province: { wwg, testimonials, stickers }
  } = props

  return [
    <Helmet
      defaultTitle={decode(p.seo.title !== '' ? p.seo.title : p.title.rendered)}
      meta={[
        {
          name: 'description',
          content: p.seo.metadesc !== '' ? p.seo.metadesc : p.excerpt.rendered
        },
        {
          name: 'og:title',
          content: p.seo['opengraph-title'] !== '' ? p.seo['opengraph-title'] : p.title.rendered
        },
        {
          name: 'og:description',
          content:
            p.seo['opengraph-description'] !== ''
              ? p.seo['opengraph-description']
              : p.excerpt.rendered
        },
        { name: 'og:url', content: `` },
        { name: 'og:site_name', content: `Democratic Alliance` },
        { name: 'og:type', content: `business` },
        { name: 'og:image', content: p.seo['opengraph-image'] || null },
        { name: 'fb:app_id', content: '1262049647255981' },
        { name: 'twitter:card', content: '”summary_large_image”' },
        { name: 'twitter:site', content: '@our_da' },
        {
          name: 'twitter:title',
          content: p.seo['twitter-title'] !== '' ? p.seo['twitter-title'] : p.title.rendered
        },
        {
          name: 'twitter:description',
          content:
            p.seo['twitter-description'] !== '' ? p.seo['twitter-description”'] : p.excerpt.rendered
        },
        {
          name: 'twitter:image',
          content: p.seo['twitter-image'] !== '' ? p.seo['twitter-image'] : null
        }
      ]}
      htmlAttributes={{ lang: 'en' }}
    />,
    <Hero
      imageUrl={wwg.hero && wwg.hero.background_image ? wwg.hero.background_image.url : null}
      title={wwg.hero && wwg.hero.headline ? wwg.hero.headline : null}
      bgPosition={wwg.hero && wwg.hero.focus_point && noComma(wwg.hero.focus_point)}
    />,
    <SectionFull mb={'large'} color={'red'}>
      <div className="col-md-7">
        <Spacing bottom size="space4">
          <Copy intro html={wwg.content} />
        </Spacing>
      </div>
    </SectionFull>,
    <Fragment>
      {testimonials.testimonial && testimonials.testimonial.length ? (
        <SectionFull
          bgColor={'light'}
          pt={'large'}
          pb={'large'}
          mb={'large'}
          container={'container'}
        >
          <SliderWrapper>
            {testimonials.testimonial.map(t => (
              <div>
                <Testimonial
                  headline={t.headline}
                  text={t.text}
                  imageUrl={t.photo.url}
                  meta={t.attribution}
                />
              </div>
            ))}
          </SliderWrapper>
        </SectionFull>
      ) : null}
    </Fragment>,

    stickers && stickers.length > 0 && (
      <SectionFull mb="large" color="red" title={`${p.title.rendered} Success Stories`}>
        <div className="col-md-12">{stickers.length && <Stickers items={stickers} />}</div>
      </SectionFull>
    ),
    <SectionFull mb={'large'} color={'red'}>
      <div className="col-md-10">
        {wwg && wwg.governments && wwg.governments.length ? (
          <Governments
            title={`Where we govern in ${p.title.rendered}`}
            list={wwg.governments}
            grid="col-md-12"
          />
        ) : null}
      </div>
    </SectionFull>,

    <SectionFull mb={'large'} color={'red'}>
      <div className="col-md-10">
        <HeadingLines lineLeft color={'red'} mb={'large'}>
          <Heading color={'red'} tracking={'huge'} size={'tiny'} weight={'regular'} uppercase>
            Where we govern in South Africa
          </Heading>
        </HeadingLines>
        <NavigationContainer
          menuId={378}
          render={menu => (
            <Fragment>
              {menu.items.map(m => (
                <ListItem title={m.title} collapsed>
                  <Spacing top bottom size="space2">
                    <div className="row">
                      {m.children.map(c => (
                        <div className="col-sm-6">
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`https://www.da.org.za/government/${c.object_slug}`}
                          >
                            <Copy hover html={c.title} override={{ display: 'inline-block' }} />
                          </a>
                        </div>
                      ))}
                    </div>
                  </Spacing>
                </ListItem>
              ))}
            </Fragment>
          )}
        />
      </div>
    </SectionFull>
  ]
}

export default WWGTemplate
